// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| CUSTOM FUNCTION - COLOR SHADOWS ||============================== //

export default function getShadow(theme: Theme, shadow: string) {
  switch (shadow) {
    case 'secondary':
      return theme.customShadows.secondary;
    case 'error':
      return theme.customShadows.error;
    case 'warning':
      return theme.customShadows.warning;
    case 'info':
      return theme.customShadows.info;
    case 'success':
      return theme.customShadows.success;
    case 'primaryButton':
      return theme.customShadows.primaryButton;
    case 'secondaryButton':
      return theme.customShadows.secondaryButton;
    case 'errorButton':
      return theme.customShadows.errorButton;
    case 'warningButton':
      return theme.customShadows.warningButton;
    case 'infoButton':
      return theme.customShadows.infoButton;
    case 'successButton':
      return theme.customShadows.successButton;
    case 'buttonShadowXS':
      return theme.customShadows.buttonShadowXS;
    case 'buttonShadowSM':
      return theme.customShadows.buttonShadowSM;
    case 'buttonShadowMD':
      return theme.customShadows.buttonShadowMD;
    case 'buttonShadowLG':
      return theme.customShadows.buttonShadowLG;
    case 'buttonShadowXL':
      return theme.customShadows.buttonShadowXL;
    case 'buttonShadow2XL':
      return theme.customShadows.buttonShadow2XL;
    case 'buttonShadow3XL':
      return theme.customShadows.buttonShadow3XL;
    default:
      return theme.customShadows.primary;
  }
}
